import { guides } from '@/mocks/clearing';
import SectionHeading from './SectionHeading';

export default function GuideSection() {
  return (
    <section id="guide" className="scroll-mt-24 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-[1180px] px-4 md:px-6">
        <SectionHeading
          index="07"
          eyebrow="How To Verify"
          title="理性吃瓜 · 求证四步法"
          desc="不站队不是不关心，而是把判断留给证据。这四步，可以套用在任何一个刚冒头的传闻上。"
        />

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {guides.map((item, index) => (
            <div
              key={item.step}
              data-reveal
              style={{ transitionDelay: `${index * 70}ms` }}
              className="flex flex-col rounded-lg bg-secondary-50 p-6 ring-1 ring-secondary-100"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-background-50 text-secondary-700">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <span className="font-heading text-2xl font-bold text-secondary-300">
                  {item.step}
                </span>
              </div>
              <h3 className="mt-5 font-heading text-[15px] font-semibold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2.5 text-[13px] leading-relaxed text-foreground-600">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

        <div
          data-reveal
          className="mt-12 flex flex-col items-start justify-between gap-6 rounded-lg border border-primary-200 bg-primary-50 p-7 md:flex-row md:items-center md:p-9"
        >
          <div>
            <h3 className="font-heading text-lg font-semibold text-foreground-950 md:text-xl">
              遇到拿不准的传闻？先别转发。
            </h3>
            <p className="mt-2 max-w-xl text-[13px] leading-relaxed text-foreground-700 md:text-sm">
              把链接、截图或时间点发给我们，编辑会按同样的流程做一次澄清与反转核对，
              结论对不上时，我们也会标明「暂无实锤」。
            </p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row">
            <a
              href="#top"
              className="flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 font-label text-sm font-medium text-background-50 transition-colors duration-200 dark:text-foreground-950 hover:bg-primary-600"
            >
              <i className="ri-send-plane-line" />
              提交线索
            </a>
            <a
              href="#ranking"
              className="flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-6 font-label text-sm font-medium text-primary-700 transition-colors duration-200 hover:bg-primary-100"
            >
              先看热度榜
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}